import styled from 'styled-components'
import {
  layout,
  space,
  typography,
  position,
  LayoutProps,
  SpaceProps,
  TypographyProps,
  PositionProps,
} from 'styled-system'
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component'
import { FunctionComponent } from 'react'

export type GenericLazyLoadImageProps = LayoutProps &
  SpaceProps &
  TypographyProps &
  LazyLoadImageProps &
  PositionProps

const GenericLazyLoadImage = styled<FunctionComponent<GenericLazyLoadImageProps>>(LazyLoadImage)`
  ${layout}
  ${space}
  ${typography}
  ${position}
`

export default GenericLazyLoadImage
